import { render, staticRenderFns } from "./ServiceListV2Cliente.vue?vue&type=template&id=46deb472&"
import script from "./ServiceListV2Cliente.vue?vue&type=script&lang=js&"
export * from "./ServiceListV2Cliente.vue?vue&type=script&lang=js&"
import style0 from "./ServiceListV2Cliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports